<script>

export default {
  data () {
    return {
      dimensionData: this.$store.getters.dataPivotDimensions
    }
  },
  created () {

  },
  methods: {
    $_dimensionUtils_getDimensionByAttribute (attribute, value) {
      let dimension
      if (attribute && value) {
        dimension = this.$store.getters.dataPivotDimensions.find(x => x[attribute] === value)
      }
      return dimension
    },
    $_dimensionUtils_getDimensionParameter (value) {
      // Receives a value and returns the dimensions (value $ key) of stores and products
      // i: retail_name
      // o: {store_dimensions: [retail_name, retail_id], product_dimensions: []}
      let dim = this.dimensionData.filter(x => x.dim_value === value)[0].dimension
      let dimKey = this.dimensionData.filter(x => x.dim_value === value)[0].dim_key
      if (dim === 'store') {
        return {store_dimensions: [value, dimKey], product_dimensions: []}
      } else if (dim === 'product') {
        return {store_dimensions: [], product_dimensions: [value, dimKey]}
      }
    },
    $_dimensionUtils_getDimensionParameterOnlyValue (value) {
      // Receives a value and returns the dimensions (value) of stores and products
      // i: retail_name
      // o: {store_dimensions: [retail_name], product_dimensions: []}
      let dim = this.dimensionData.filter(x => x.dim_value === value)[0].dimension
      if (dim === 'store') {
        return {store_dimensions: [value], product_dimensions: []}
      } else if (dim === 'product') {
        return {store_dimensions: [], product_dimensions: [value]}
      }
    },
    $_dimensionUtils_getDimensionParameterComplete (obj) {
      // Receives the complete parameter object and returns the dimensions of stores and products
      // ie: {store_dimensions: [], product_dimensions: [value1, value2]}
      if (obj.parameters.store_dimensions.length > 0) {
        let value = obj.parameters.store_dimensions[0]
        let dimValue = this.dimensionData.filter(x => x.dim_value === value)[0].dim_value
        let dimKey = this.dimensionData.filter(x => x.dim_value === value)[0].dim_key
        return {store_dimensions: [dimValue, dimKey], product_dimensions: []}
      } else if (obj.parameters.product_dimensions.length > 0) {
        let value = obj.parameters.product_dimensions[0]
        let dimValue = this.dimensionData.filter(x => x.dim_value === value)[0].dim_value
        let dimKey = this.dimensionData.filter(x => x.dim_value === value)[0].dim_key
        return {store_dimensions: [], product_dimensions: [dimValue, dimKey]}
      }
    },
    $_dimensionUtils_getDimFromDimensionParameterComplete (obj) {
      // Receives the complete parameter object and returns the main dim value
      // ie return: retail_name
      if (obj.parameters.store_dimensions.length > 0) {
        return obj.parameters.store_dimensions[0]
      } else if (obj.parameters.product_dimensions.length > 0) {
        return obj.parameters.product_dimensions[0]
      }
    },
    $_dimensionUtils_getDimFromDimension (obj) {
      // Receives the dimension parameter object and returns the main dim value
      // ie receives: {store_dimensions: [], product_dimensions: [value1, value2]}
      // ie return: retail_name
      if (obj.store_dimensions.length > 0) {
        return obj.store_dimensions[0]
      } else if (obj.product_dimensions.length > 0) {
        return obj.product_dimensions[0]
      }
    },
    $_dimensionUtils_gridParameterBuilder (obj) {
      // TODO
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/DimensionUtils.vue